var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-form-model",
    {
      ref: "form",
      attrs: { slot: "detail", model: _vm.model },
      slot: "detail"
    },
    [
      _c(
        "a-col",
        { attrs: { span: 12 } },
        [
          _c(
            "a-form-model-item",
            {
              attrs: {
                label: "单据编号",
                labelCol: _vm.labelCol,
                wrapperCol: _vm.wrapperCol
              }
            },
            [
              _c("a-input", {
                attrs: { disabled: _vm.isDisabled },
                model: {
                  value: _vm.model.business_form_no,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "business_form_no", $$v)
                  },
                  expression: "model.business_form_no"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "a-col",
        { attrs: { span: 12 } },
        [
          _c(
            "a-form-model-item",
            {
              attrs: {
                label: "隐患程度",
                labelCol: _vm.labelCol,
                wrapperCol: _vm.wrapperCol
              }
            },
            [
              _c("j-dict-select-tag", {
                attrs: {
                  type: "list",
                  dictCode: "ep_danger_level",
                  disabled: _vm.isDisabled
                },
                model: {
                  value: _vm.epDanger.dangerLevel,
                  callback: function($$v) {
                    _vm.$set(_vm.epDanger, "dangerLevel", $$v)
                  },
                  expression: "epDanger.dangerLevel"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "a-col",
        { attrs: { span: 12 } },
        [
          _c(
            "a-form-model-item",
            {
              attrs: {
                label: "隐患地点",
                labelCol: _vm.labelCol,
                wrapperCol: _vm.wrapperCol
              }
            },
            [
              _c("a-input", {
                attrs: { disabled: _vm.isDisabled },
                model: {
                  value: _vm.epDanger.dangerAddress,
                  callback: function($$v) {
                    _vm.$set(_vm.epDanger, "dangerAddress", $$v)
                  },
                  expression: "epDanger.dangerAddress"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "a-col",
        { attrs: { span: 12 } },
        [
          _c(
            "a-form-model-item",
            {
              attrs: {
                label: "整改期限",
                labelCol: _vm.labelCol,
                wrapperCol: _vm.wrapperCol
              }
            },
            [
              _c("j-date", {
                staticStyle: { width: "100%" },
                attrs: { format: _vm.dateFormat, disabled: _vm.isDisabled },
                model: {
                  value: _vm.epDanger.correctiveTerm,
                  callback: function($$v) {
                    _vm.$set(_vm.epDanger, "correctiveTerm", $$v)
                  },
                  expression: "epDanger.correctiveTerm"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.model.model_code == "HiddenDangerForm"
        ? _c(
            "span",
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "设为罚扣",
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c("j-switch", {
                        attrs: { disabled: _vm.isDisabled },
                        model: {
                          value: _vm.epDanger.isPenalty,
                          callback: function($$v) {
                            _vm.$set(_vm.epDanger, "isPenalty", $$v)
                          },
                          expression: "epDanger.isPenalty"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.epDanger.isPenalty == "Y"
                ? _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "罚扣金额",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: _vm.isDisabled },
                            model: {
                              value: _vm.epDanger.penaltyMoney,
                              callback: function($$v) {
                                _vm.$set(_vm.epDanger, "penaltyMoney", $$v)
                              },
                              expression: "epDanger.penaltyMoney"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "事业群",
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c("j-select-depart", {
                        attrs: {
                          multi: false,
                          backDepart: true,
                          disabled: _vm.isDisabled
                        },
                        model: {
                          value: _vm.epDanger.businessGroupId,
                          callback: function($$v) {
                            _vm.$set(_vm.epDanger, "businessGroupId", $$v)
                          },
                          expression: "epDanger.businessGroupId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "事业处",
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c("j-select-depart", {
                        attrs: {
                          multi: false,
                          backDepart: true,
                          disabled: _vm.isDisabled
                        },
                        model: {
                          value: _vm.epDanger.businessUnitId,
                          callback: function($$v) {
                            _vm.$set(_vm.epDanger, "businessUnitId", $$v)
                          },
                          expression: "epDanger.businessUnitId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.model.model_code == "DelayForm"
        ? _c(
            "span",
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "延期后整改期限",
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c("j-date", {
                        staticStyle: { width: "100%" },
                        attrs: { disabled: _vm.isDisabled },
                        model: {
                          value: _vm.epDanger.deferCorrectiveTerm,
                          callback: function($$v) {
                            _vm.$set(_vm.epDanger, "deferCorrectiveTerm", $$v)
                          },
                          expression: "epDanger.deferCorrectiveTerm"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: "延期申請緣由",
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          disabled: _vm.isDisabled,
                          title: _vm.epDanger.deferRequestReason
                        },
                        model: {
                          value: _vm.epDanger.deferRequestReason,
                          callback: function($$v) {
                            _vm.$set(_vm.epDanger, "deferRequestReason", $$v)
                          },
                          expression: "epDanger.deferRequestReason"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "a-col",
        { attrs: { span: 24 } },
        [
          _c(
            "a-form-model-item",
            {
              attrs: {
                label: "隐患描述",
                labelCol: _vm.labelCol2,
                wrapperCol: _vm.wrapperCol2
              }
            },
            [
              _c("a-textarea", {
                attrs: {
                  rows: "2",
                  disabled: _vm.isDisabled,
                  title: _vm.epDanger.dangerDescription
                },
                model: {
                  value: _vm.epDanger.dangerDescription,
                  callback: function($$v) {
                    _vm.$set(_vm.epDanger, "dangerDescription", $$v)
                  },
                  expression: "epDanger.dangerDescription"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }